<template>
    <Navbar></Navbar>
    <div class="contact-hero">
        <div class="contact-us-title">
            Join Us
        </div>
        <div class="contact-hero-inner">
            <div class="contact-hero-card">
                <div class="contact-hero-inner-item">
                    <div class="contact-hero-company">FINEST Automotive Technology Group Co., Ltd.</div>
                    <div class="contact-hero-addr">Address: No.75, Dongsheng Road, East Second Ring Road, Lianchi District, Baoding City,<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Hebei Province.</div>
                    <div class="contact-hero-addr">E-mail:&nbsp;&nbsp;&nbsp;fczp@finestauto.com</div>
                    <div class="contact-hero-addr">Contact: Manager Wang</div>
                    <div class="contact-hero-addr">Phone:&nbsp;&nbsp;&nbsp;+86-18531241011</div>
                </div>
            </div>
            <div class="contact-hero-map">
                <div class="map-img">
                    <img data-src="/assets/contact/map.jpg" alt="contact map">
                </div>
            </div>
        </div>
    </div>

    <div class="contact-us">
        <div class="contact-us-tab">
            <div class="contact-tab-item" v-for="(item, index) in pageData" :key="index" :class="activeTab == index + 1 ? 'active' : ''" @click="activeTab = index + 1">
                <div class="contact-us-title-text">
                    {{ item.title }}
                </div>
                <div class="contact-us-desc">
                    <div class="contact-us-type">
                        {{ item.type }}
                    </div>
                    <div class="contact-us-address">
                        <img data-src="/assets/contact/address-icon.png" alt="" class="contact-us-address-icon">
                        <div>
                            {{ item.location }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="contact-us-container">
            <div class="us-container-item" v-for="(item, index) in pageData" :key="index" v-show="activeTab == index + 1">
                <div class="container-item-title">
                    Job Description
                </div>
                <div class="container-item-content">

                    <div class="container-item-address">
                        <div class="container-item-address-type">
                            {{ item.type }}
                        </div>
                        <img data-src="/assets/contact/address-icon.png" alt="" class="contact-us-address-icon">
                        <div class="container-item-address-text">
                            {{ item.location }}
                        </div>
                    </div>

                    <div class="container-item-time">
                        {{ item.time }}
                    </div>

                </div>

                <div class="container-item-responsibility">
                    Responsibilities
                </div>
                <div class="container-item-desc" v-for="(content, contentIndex) in item.content" :key="contentIndex">
                    {{ content }}
                </div>

                <div class="container-item-responsibility">
                    Requirements
                </div>
                <div class="container-item-desc" v-for="(value, valueIndex) in item.requirement" :key="valueIndex">
                    {{ value }}
                </div>

            </div>

        </div>
    </div>


    <Footer></Footer>
</template>

<script setup>
import { ref , reactive } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';

const activeTab = ref(1);
const pageData = reactive([
    {
        title:'Lean Management Engineer',
        type:'Full-time',
        location:'Baoding·Hebei',
        time:'2026-01-20 Post Time',
        content:[
            '① Develop and promote the company’s annual/monthly lean production plans; supervise the implementation and optimization of the production system',
            '② Improve process flows and management standards; organize production coordination and scheduling to enhance efficiency and achieve targets',
        ],
        requirement:[
            '① 5+ years of experience in lean production within the vehicle manufacturing industry; familiar with stamping processes, equipment, and lean management methods',
            '② Strong communication, organizational, and logical thinking skills; proficient in using office software',
        ]
    },
    {
        title:'Quality expert',
        type:'Full-time',
        location:'Baoding·Hebei',
        time:'2026-01-20 Post Time',
        content:[
            '① Plan, establish, improve, and monitor the company’s quality management system',
            '② Develop quality policies and objectives; guide daily operations and promote continuous improvement',
            '③ Organize and execute project, system, and process audits to identify risks and implement corrective actions',
        ],
        requirement:[
            '① Bachelor’s degree or above (may be relaxed to associate degree for highly experienced candidates). 10+ years of experience in quality/technical roles in automotive or auto parts manufacturing. Proficient in IATF 16949, VDA 6.3, APQP, FMEA, etc',
            '② Preferred majors: Quality Management, Mechanical Engineering, Automotive, Electromechanical, Materials, Automation, Electronics, or related fields',
        ]
    },{
        title:'Chief Engineer of Diagnostic Function Calibration',
        type:'Full-time',
        location:'Baoding·Hebei',
        time:'2026-01-20 Post Time',
        content:[
            '① Establish and coordinate the diagnosis and calibration process system, leading the development and implementation of core system diagnosis',
            '② Promote the implementation of global technical standards and coordinate cross-departmental efforts to tackle critical challenges',
            '③ Organize the cultivation and development of professional talent pipelines',
            '④ Manage project milestones and delivery quality, and establish a rapid fault response mechanism',
        ],
        requirement:[
            '① Over 10-year experience TCU/MCU/ACU diagnostic and calibration development, familiarity with global diagnostic development processes, and hands-on experience in mass production projects',
            '② Proficient in diagnostic protocols such as UDS and OBD.Proficient in Model-Based Development (MBD) and calibration/testing tools.',
            '③ Experience in the complete diagnostic development process and overseas project collaboration is preferred',
            '④ Strong team management and communication skills, with the ability to work under pressure',
        ]
    },
    
]);




</script>

<script>
export const pageConfig = {
  title: 'Join Us - FINEST Website',
  keywords: 'FINEST,Engine,Transmission,Electronics',
  description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
  outputPath: 'en/join-us.html'
};

import { createApp } from 'vue';
import App from './join-us.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss"

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}


// 页面加载完成后挂载
document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./join-us.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped>
.contact-hero {
    padding: 2.1rem 1.56rem 0rem;
    width: calc(100% - 3.12rem);

    .contact-us-title {
        font-size: 0.4rem;
        font-weight: 500;
        color: #000;
        margin-bottom: 0.4rem;
    }

    .contact-hero-inner {
        display: flex;
        align-items: stretch;
        justify-content: space-between;
    }

    .contact-hero-card {
        width: 49.3%;
        border-radius: 0.25rem;
        background: #F6F8FA;
        display: flex;
        flex-direction: column;

        .contact-hero-inner-item {
            padding: 0.58rem 0.44rem;
        }

        .contact-hero-title {
            font-size: 0.5rem;
            font-weight: 500;
            margin-bottom: 0.3rem;
        }

        .contact-hero-company {
            font-size: 0.28rem;
            font-weight: 700;
            color: #000;
            margin-bottom: 0.56rem;
            position: relative;

            &::after {
                content: '';
                position: absolute;
                width: 0.38rem;
                height: 0.02rem;
                background: linear-gradient(135deg, #E70012 0%, #EA5433 100%);
                bottom: -0.2rem;
                left: 0;
            }
        }

        .contact-hero-addr {
            font-size: 0.16rem;
            color: #999;
            line-height: 0.3rem;
        }
    }

    .contact-hero-map {
        width: 49.3%;

        .map-img {
            width: 100%;
            height: 100%;
            border-radius: 0.25rem;
            overflow: hidden;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                display: block;
            }
        }
    }

    @media (max-width: 768px) {
        .contact-hero-inner {
            flex-direction: column;
        }

        .contact-hero-card,
        .contact-hero-map {
            width: 100%;
        }

        .contact-hero-map {
            .map-img {
                height: 8rem;
            }
        }
    }
}

.contact-us {
    padding: 0.25rem 1.56rem;
    width: calc(100% - 3.12rem);
    display: flex;
    gap: 0.25rem;

    .contact-us-tab {
        display: flex;
        align-items: stretch;
        justify-content: flex-start;
        flex-direction: column;
        width: auto;
        gap: 0.24rem;

        .contact-tab-item {
            width: 2.7rem;
            min-height: 0.62rem;
            background: #F6F8FA;
            border-radius: 0.15rem;
            padding: 0.36rem 0.44rem;
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            transition: all 0.5s;
            cursor: pointer;
            gap: 0.2rem;

            &.active {
                background: rgba(231, 0, 18, 0.04);
                border: 1px solid #E70012;
            }

            .contact-us-title-text {
                font-size: 0.25rem;
                font-weight: 600;
                color: #000;
            }

            .contact-us-desc {
                display: flex;
                width: 100%;

                .contact-us-type {
                    font-size: 0.18rem;
                    color: #000;
                    font-weight: 400;
                    position: relative;
                    margin-right: 0.3rem;

                    &::after {
                        content: '';
                        position: absolute;
                        width: 0.01rem;
                        height: 0.14rem;
                        background: #D5D5D5;
                        right: -0.15rem;
                        top: 50%;
                        transform: translateY(-50%);
                    }
                }

                .contact-us-address {
                    display: flex;
                    align-items: center;

                    img.contact-us-address-icon {
                        width: 0.16rem;
                        height: 0.16rem;
                        margin-right: 0.1rem;
                    }

                    div {
                        font-size: 0.18rem;
                        color: #000;
                    }
                }
            }
        }
    }

    .contact-us-container {
        width: 11.18rem;
        min-height: 4.5rem;
        position: relative;

        .us-container-item {
            position: sticky;
            top: 0;
            left: 0;
            width: 100%;
            height: auto;
            min-height: 5.38rem;
            background: #F6F8FA;
            border-radius: 0.15rem;
            padding: 0.36rem 0.53rem;

            .container-item-title {
                font-weight: bold;
                font-size: 0.25rem;
                color: #000000;
            }
            .container-item-content{
                margin-top: 0.2rem;
                display: flex;
                justify-content: space-between;
                .container-item-address{
                    display: flex;
                    align-items: center;
                    .container-item-address-type{
                        font-weight: 400;
                        font-size: 0.18rem;
                        margin-right: 0.58rem;
                        position: relative;
                        &::after{
                            content: '';
                            width: 0.02rem;
                            height: 0.14rem;
                            background: #D5D5D5;
                            position: absolute;
                            right: -0.29rem;
                            top: 50%;
                            transform: translateY(-50%);
                        }
                    }
                    .contact-us-address-icon{
                         width: 0.16rem;
                         height: 0.16rem;
                    }
                    .container-item-address-text{
                        font-weight: 400;
                        font-size: 0.16rem;
                        margin-left: 0.05rem;
                    }

                }
                .container-item-time{
                    font-weight: 400;
                    font-size: 0.18rem;
                    color: #999;
                }

            }
            .container-item-responsibility {
                margin-top: 0.46rem;
                font-weight: bold;
                font-size: 0.2rem;
                color: #000000;
                margin-bottom: 0.23rem;
            }
            .container-item-desc {
                font-weight: 400;
                font-size: 0.18rem;
                color: #000000;
                line-height: 0.3rem;
                margin-bottom: 0.1rem;
            }
        }
    }

}
@media (max-width: 768px) {
    .contact-hero {
        padding: 2.02rem 0.45rem 0;
        width: calc(100% - 0.9rem);

        .contact-hero-inner {
            flex-direction: column-reverse;
            background: #F6F8FA;

            .contact-hero-card {
                width: 100%;

                .contact-hero-addr {
                    font-size: 0.2rem;
                    color: #000;
                }
            }

            .contact-hero-map {
                width: 100%;
            }
        }
    }
    .contact-us {
        flex-direction: column;
        padding: 0.5rem 0.45rem;
        width: calc(100% - 0.9rem);
        .contact-us-tab{
            width: 100%;
            flex-direction: row;
            .contact-tab-item{
                width: auto;
                padding: 0.2rem 0.29rem;
                min-height: auto;
            
                .contact-us-title-text{ 
                    font-size: 0.22rem;
                }
                .contact-us-desc{
                    display: none;
                }
            }
        }
        .contact-us-container{
            width: 100%;
            .us-container-item{
                padding: 0.2rem 0.29rem;
                width: calc(100% - 0.58rem);
                .container-item-title{
                    font-size: 0.28rem;
                }
                .container-item-content{
                    .container-item-address{

                        .container-item-address-type{
                            font-size: 0.2rem;
                        }
                        .container-item-address-text{
                            font-size: 0.2rem;
                        }
                    }
                    .container-item-time{
                        font-size: 0.2rem;
                    }
                }
                .container-item-responsibility{
                    font-size: 0.28rem;
                }
                .container-item-desc{
                    font-size: 0.2rem;
                }
            }

        }
    }
}
</style>